'use client';

/**
 * Framework Provider
 * Combines all framework providers in the correct order
 */
import React, { ReactNode } from 'react';

import { SessionProvider } from '../components/providers/SessionProvider';
import { AppConfig } from '../core/config/manager';
import { EnhancedConfigProvider } from './EnhancedConfigProvider';
import { EnhancedThemeProvider } from './EnhancedThemeProvider';

export interface FrameworkProviderProps {
  children: ReactNode;
  initialConfig?: Partial<AppConfig>;
}

export const FrameworkProvider: React.FC<FrameworkProviderProps> = ({ children, initialConfig }) => {
  return (
    <SessionProvider>
      <EnhancedConfigProvider initialConfig={initialConfig}>
        <EnhancedThemeProvider>{children}</EnhancedThemeProvider>
      </EnhancedConfigProvider>
    </SessionProvider>
  );
};
